<button
  class="ta-controls__btn-icon"
  type="button"
  puButton
  size="m"
  uiType="quaternary"
  [onlyIcon]="true"
  (click)="toggleTheme()"
>
  <pu-icon [iconName]="uiStore.isDarkTheme() ? 'light' : 'dark'"/>
</button>
